import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgSolidChevronRight = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      fillRule="evenodd"
      d="m6.037 11.873 4.723-3.422c.276-.199.32-.563.1-.812a.6.6 0 0 0-.1-.09L6.037 4.127a.684.684 0 0 0-.897.09.55.55 0 0 0-.14.361v6.844c0 .32.286.578.638.578a.7.7 0 0 0 .4-.127"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgSolidChevronRight);
export default ForwardRef;
